import { render, staticRenderFns } from "./Ordering.vue?vue&type=template&id=404ebf71&"
import script from "./Ordering.vue?vue&type=script&lang=js&"
export * from "./Ordering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports